import { render } from "./growth-table.vue?vue&type=template&id=ca26f58a"
import script from "./growth-table.vue?vue&type=script&lang=js"
export * from "./growth-table.vue?vue&type=script&lang=js"

import "./growth-table.vue?vue&type=style&index=0&id=ca26f58a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__